<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">طلب عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">طلب عقار</li>
            </ol>
          </div>
        </div>
        <div v-if="checkAccess('property_requests_create')" class="row mt-2">
          <div class="col text-end">
            <router-link to="/proRequest/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة طلب عقار
            </router-link>
          </div>
        </div>
        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="regionSelect" v-model="searchRegion" class="form-control">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regions" :key="r.id" :value="r.id">{{ r.name }}</option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="citiesSelect" v-model="searchCity" class="form-control">
                      <option :value="null">المدينة</option>
                      <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="neighborhoodSelect" v-model="searchNeighborhood" class="form-control" :disabled="!searchCity">
                      <option :value="null">الحي</option>
                      <option v-for="n in neighborhoods" :key="n.id" :value="n.id">{{ n.name }}</option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchStatus" class="form-control">
                      <option :value="null">الحالة</option>
                      <option v-for="(label, key) in statusTranslate" :key="key" :value="key">{{ label }}</option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 mb-3">
                    <select v-model="searchPurpose" class="form-control">
                      <option :value="null">نوع الطلب</option>
                      <option v-for="(label, key) in purposeChoices" :key="key" :value="key">{{ label }}</option>
                    </select>
                  </div>

                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">طلب عقار</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>العميل</th>
                            <th>نوع الطلب</th>
                            <th>المنطقة</th>
                            <th>المدينة</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.User.name }}</td>
                            <td>
                              <span v-if="row.purpose == 'for_sale'" class="badge bg-success">للبيع</span>
                              <span v-else-if="row.purpose == 'for_rent'" class="badge bg-info">للإيجار</span>
                              <span v-else>—</span>
                            </td>
                            <td>{{ row.Region?.name ?? '—' }}</td>
                            <td>{{ row.City?.name ?? '—' }}</td>
                            <td>{{ statusTranslate[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/proRequest/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('property_requests_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('property_requests_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'ProRequestList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      statusTranslate: {},
      searchName: this.$route.query.name || '',
      purposeChoices: {},
      searchRegion: this.$route.query.region || null,
      searchCity: this.$route.query.city || null,
      searchNeighborhood: this.$route.query.neighborhood || null,
      searchStatus: this.$route.query.status || null,
      searchPurpose: this.$route.query.purpose || null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      regions: [],
      cities: [],
      neighborhoods: [],
      showDateFilter: false,
      countRows: 0,
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;

      const params = new URLSearchParams({ page: this.currentPage });

      if (this.searchName) params.append('name', this.searchName);
      if (this.searchRegion) params.append('regionId', this.searchRegion);
      if (this.searchCity) params.append('cityId', this.searchCity);
      if (this.searchNeighborhood) params.append('neighborhoodId', this.searchNeighborhood);
      if (this.searchStatus) params.append('status', this.searchStatus);
      if (this.searchPurpose) params.append('purpose', this.searchPurpose);
      if (this.searchDateFrom) params.append('dateFrom', this.searchDateFrom);
      if (this.searchDateTo) params.append('dateTo', this.searchDateTo);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchRegion !== null && this.searchRegion !== '' && this.searchRegion !== false ? { region: this.searchRegion } : {}),
        ...(this.searchCity !== null && this.searchCity !== '' && this.searchCity !== false ? { city: this.searchCity } : {}),
        ...(this.searchNeighborhood !== null && this.searchNeighborhood !== '' && this.searchNeighborhood !== false ? { neighborhood: this.searchNeighborhood } : {}),
        ...(this.searchStatus !== null && this.searchStatus !== '' && this.searchStatus !== false ? { status: this.searchStatus } : {}),
        ...(this.searchPurpose !== null && this.searchPurpose !== '' && this.searchPurpose !== false ? { purpose: this.searchPurpose } : {}),
        ...(this.searchDateFrom !== null && this.searchDateFrom !== '' && this.searchDateFrom !== false ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo !== null && this.searchDateTo !== '' && this.searchDateTo !== false ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/propertyRequests/list?${params}`).then(({data}) => {
        this.rows = data.rows;
        this.statusTranslate = data.statusChoices;
        this.purposeChoices = data.purposeChoices ?? {};
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/propertyRequests/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit() {
      this.currentPage = 1; 
      this.getList();
    },
    clearFilter() {
      this.searchName = '';
      this.searchRegion = null;
      this.searchCity = null;
      this.searchNeighborhood = null;
      this.cities = [];
      this.neighborhoods = [];
      this.searchStatus = null;
      this.searchPurpose = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;

      this.currentPage = 1;
      this.$router.replace({ query: {} }).catch(() => {});
      this.$nextTick(() => {
        this.applySelect2Regions();
        this.applySelect2Cities();
        this.applySelect2Neighborhoods();
      });
      this.getList();
    },
    getRegions(){
      this.$http.get('/api/admin/regions/list').then(({data}) => {
        this.regions = data.regions || [];
        this.$nextTick(() => this.applySelect2Regions());
      });
    },
    getCities(){
      this.$http.get('/api/admin/cities/list').then(({data}) => {
        this.cities = data.cities || [];
      });
    },
    applySelect2Regions(){
      if(!this.$refs.regionSelect){
        setTimeout(() => this.applySelect2Regions(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.regionSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.regionSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.regionSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchRegion) return;
          myInstance.searchRegion = newVal;
        });
    },
    applySelect2Cities(){
      if(!this.$refs.citiesSelect){
        setTimeout(() => this.applySelect2Cities(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.citiesSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.citiesSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.citiesSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchCity) return;
          myInstance.searchCity = newVal;
        });
    },
    applySelect2Neighborhoods(){
      if(!this.$refs.neighborhoodSelect){
        setTimeout(() => this.applySelect2Neighborhoods(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.neighborhoodSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.neighborhoodSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.neighborhoodSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchNeighborhood) return;
          myInstance.searchNeighborhood = newVal;
        });
    },
  },
  created(){
    this.getRegions();
    this.getList();
  },
  mounted(){
    this.$nextTick(() => {
      this.applySelect2Cities();
      this.applySelect2Neighborhoods();
    });
  },
  watch: {
    searchRegion(newVal){
      this.searchCity = null;
      this.searchNeighborhood = null;
      this.neighborhoods = [];

      if(newVal){
        this.$http.get(`/api/admin/cities/list?regionId=${newVal}&all=1`)
          .then(({data}) => {
            this.cities = data.cities || [];
            this.$nextTick(() => this.applySelect2Cities());
          });
      } else {
        this.cities = [];
        this.$nextTick(() => this.applySelect2Cities());
      }
    },
    searchCity(newVal){
      this.searchNeighborhood = null;
      this.neighborhoods = [];

      if(newVal){
        this.$http.get(`/api/admin/neighborhoods/list?cityId=${newVal}&all=1`)
          .then(({data}) => {
            this.neighborhoods = data.neighborhoods || [];
            this.$nextTick(() => this.applySelect2Neighborhoods());
          });
      } else {
        this.neighborhoods = [];
        this.$nextTick(() => this.applySelect2Neighborhoods());
      }
    }
  },
}
</script>